(() => {
  if (window.LsDistribution) return;
  window.LsDistribution = true;

  const fill = (str, map) => String(str || '').replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));

  /* Reveal: only content that starts off screen is hidden, so nothing visible ever blinks. */
  const reveal = () => {
    const roots = document.querySelectorAll('[data-lsd]:not([data-lsd-ready])');
    if (!roots.length || !('IntersectionObserver' in window)) return;
    const src = roots[0].dataset.gsapSrc;
    const load = window.lsLoadGsap ? window.lsLoadGsap(src) : Promise.resolve(window.gsap);
    load.then((gsap) => {
      if (!gsap) return;
      const mm = gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', () => {
        roots.forEach((root) => {
          root.dataset.lsdReady = '';
          const r = root.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.9) return;
          const els = root.querySelectorAll('[data-lsd-reveal], [data-lsd-item]');
          if (!els.length) return;
          gsap.set(els, { autoAlpha: 0, y: 18 });
          const io = new IntersectionObserver((entries) => {
            if (!entries.some((e) => e.isIntersecting)) return;
            io.disconnect();
            gsap.to(els, { autoAlpha: 1, y: 0, duration: 0.7, ease: 'power3.out', stagger: 0.05, clearProps: 'transform,opacity,visibility' });
          }, { rootMargin: '0px 0px -12% 0px' });
          io.observe(root);
        });
      });
    }).catch(() => {});
  };

  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;opacity:0';
    document.body.append(ta);
    ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    if (!ok) throw new Error('copy');
  };

  const inquiry = (form) => {
    if (form.dataset.lsdBound) return;
    form.dataset.lsdBound = '1';
    const d = form.dataset;
    const status = form.querySelector('[data-lsd-status]');
    const say = (msg) => {
      status.textContent = '';
      requestAnimationFrame(() => { status.textContent = msg; });
    };

    const setError = (input, msg) => {
      const err = document.getElementById(input.id + '-err');
      if (msg) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      if (err) err.textContent = msg || '';
    };

    const check = (input) => {
      const v = input.value.trim();
      if (input.required && !v) return fill(d.errorRequired, { field: (input.dataset.label || '').toLowerCase() });
      if (input.type === 'url' && v && !/^https?:\/\/\S+\.\S+/i.test(v)) return d.errorUrl;
      return '';
    };

    form.querySelectorAll('input[type="text"], input[type="url"]').forEach((input) => {
      input.addEventListener('blur', () => { if (input.value.trim()) setError(input, check(input)); });
      input.addEventListener('input', () => { if (input.hasAttribute('aria-invalid')) setError(input, check(input)); });
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      let first = null;
      form.querySelectorAll('input[type="text"], input[type="url"]').forEach((input) => {
        const msg = check(input);
        setError(input, msg);
        if (msg && !first) first = input;
      });
      if (first) { first.focus(); return; }

      const val = (name) => {
        const el = form.elements[name];
        return el ? String(el.value || '').trim() : '';
      };
      const map = { company: val('company'), country: val('country') };
      const lines = [d.intro || '', ''];
      form.querySelectorAll('[data-label]').forEach((el) => {
        let v = '';
        if (el.tagName === 'FIELDSET') {
          const on = el.querySelector('input:checked');
          v = on ? on.value : '';
        } else {
          v = el.value.trim();
        }
        if (v) lines.push(el.dataset.label + ': ' + v);
      });
      const href = 'mailto:' + d.email +
        '?subject=' + encodeURIComponent(fill(d.subject, map)) +
        '&body=' + encodeURIComponent(lines.join('\n').trim() + '\n');
      window.location.href = href;
      say(fill(d.statusOpened, { email: d.email }));
    });

    const copy = form.querySelector('[data-lsd-copy]');
    if (copy) {
      let t = 0;
      copy.addEventListener('click', () => {
        const email = copy.dataset.lsdCopy;
        copyText(email).then(() => {
          copy.classList.add('is-done');
          say(fill(d.statusCopied, { email }));
          clearTimeout(t);
          t = setTimeout(() => copy.classList.remove('is-done'), 1800);
        }).catch(() => say(fill(d.statusCopyFailed, { email })));
      });
    }
  };

  const init = () => {
    reveal();
    document.querySelectorAll('[data-lsd-inquiry]').forEach(inquiry);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
